<template lang="pug">
  .select-technician
    div
      //- BOTON RECHAZADO
      //-Hace ingreso a bodega un equipo en estado Rechazado
      button.change-button(
        :disabled="disabled || loading"
        title="Ingresar a bodega"
        @click="crearMovimientoBodega(1, 6, 0, 'Bodega')")
        b-spinner(v-if="loading" small)
        span {{ loading ? 'Procesando...' : 'Ingresar a bodega rechazado' }}
</template>

<script>
import { ACTION_NAMES } from '@/utils/enums/actions'
import moment from 'moment'
import { mapActions } from 'vuex'
import LoadingButtonMixin from '@/mixins/LoadingButtonMixin'

export default {
  name: 'ActionIngresarABodegaRechazado',
  mixins: [LoadingButtonMixin],
  props: ['ot', 'disabled'],

  data() {
    return {
      user: null,
      isBodega: false,
    }
  },
  created() {
    const { user } = JSON.parse(localStorage.getItem('user'))
    this.user = user
  },
  methods: {
    ...mapActions('Warehouse', ['saveMovement']),
    ...mapActions('OTStore', ['editOT', 'getOT']),
    async crearMovimientoBodega(
      t_movimiento,
      t_entrada,
      t_salida,
      ubicacion_ot
    ) {
      try {
        await this.executeWithLoading(async () => {
          // Se realiza Condicional en caso de no tener un tecnico asignado aun 
          const data = {
            ot: this.ot.ot,
            tipo_movimiento: t_movimiento,
            tipo_entrada: t_entrada,
            tipo_salida: t_salida,
            entregado_por: this.ot.tecnico_asignado?.id ? this.ot.tecnico_asignado?.id : null,
            recibido_por: this.user.id,
          }
          const resp = await this.saveMovement(data)
          if (resp.status === 200) {
            await this.editOT({
              ot: this.ot.ot,
              ubicacion: ubicacion_ot,
              action: ACTION_NAMES.ingresarABodegaRechazado,
            })
            this.$bvToast.toast(
              `OT ingresada a las ${moment(resp.data.fecha_hora).format(
                'DD/MM/YYYY HH:mm'
              )}`,
              {
                variant: 'success',
              }
            )
            this.$emit('changed')
            await this.getOT(this.ot.ot)
          } else {
            this.$bvToast.toast(
              `Error al crear el movimiento de bodega: ${resp.data}`,
              {
                variant: 'danger',
              }
            )
          }
        })
      } catch (error) {
        console.error('Error al crear movimiento de bodega:', error)
        this.$bvToast.toast('Error al ingresar a bodega', {
          variant: 'danger',
        })
      }
    },
  },
}
</script>
